import { FEATURED_BRANDS } from '@/_utils/Constants'
import { getBrandSlug, resolveBrandId } from '@/_lib/brand-href'

export function getProductHref(
  identifier: string | undefined | null,
  brandId?: string | null,
): string {
  if (!identifier) return '#'
  const resolvedBrandId = brandId ? resolveBrandId(brandId) : ''
  if (!resolvedBrandId || resolvedBrandId === FEATURED_BRANDS.yaponamama) {
    return `/product/${identifier}`
  }
  return `/brand/${getBrandSlug(resolvedBrandId)}/product/${identifier}`
}
